(function () {
  // Suppress the CSS second-image hover effect while a swatch is being hovered,
  // so the swatch variant image is the only thing that changes.
  var style = document.createElement('style');
  style.textContent =
    '.product-card__image-wrapper.swatch-hover-active .product-card__image--main { opacity: 1 !important; }' +
    '.product-card__image-wrapper.swatch-hover-active .product-card__image--second { opacity: 0 !important; visibility: hidden !important; }';
  document.head.appendChild(style);

  function swapImage(imageWrapper, img, variantImageUrl) {
    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.getAttribute('src') || '';
      img.dataset.originalSrcset = img.getAttribute('srcset') || '';
    }
    imageWrapper.classList.add('swatch-hover-active');
    img.removeAttribute('srcset');
    img.src = variantImageUrl;
  }

  function restoreImage(imageWrapper, img) {
    if (!img.dataset.originalSrc) return;
    imageWrapper.classList.remove('swatch-hover-active');
    img.src = img.dataset.originalSrc;
    if (img.dataset.originalSrcset) {
      img.srcset = img.dataset.originalSrcset;
    }
    delete img.dataset.originalSrc;
    delete img.dataset.originalSrcset;
  }

  document.addEventListener('mouseover', function (e) {
    var li = e.target.closest('.swatches--product-card li[data-variant-image]');
    if (!li) return;

    var card = li.closest('.product-card');
    if (!card) return;

    var imageWrapper = card.querySelector('.product-card__image-wrapper');
    var img = imageWrapper && imageWrapper.querySelector('.product-card__image--main img');
    if (!img) return;

    swapImage(imageWrapper, img, li.dataset.variantImage);
  });

  document.addEventListener('mouseout', function (e) {
    var li = e.target.closest('.swatches--product-card li[data-variant-image]');
    if (!li) return;

    // Don't restore if the cursor is still within the same li
    if (li.contains(e.relatedTarget)) return;

    var card = li.closest('.product-card');
    if (!card) return;

    var imageWrapper = card.querySelector('.product-card__image-wrapper');
    var img = imageWrapper && imageWrapper.querySelector('.product-card__image--main img');
    if (!img) return;

    restoreImage(imageWrapper, img);
  });
})();
